import React, {  } from 'react';
import {Field, ErrorMessage  } from 'formik';
import  {Box, Alert} from '@mui/material/';
import '../../../../css/report.css'

function InputField (props) {

    const { type, symptom, ...rest} = props
    const { label, name } = props.symptom
   
    return (
        <Box sx={{border:"solid", borderColor:"grey.300",borderRadius:"10px", width:"auto", margin:1}}>
        <label htmlFor={name}> {label} </label>
        <Field className="modalInputBox" type={type} id={name}  name={name} {...rest} />
        <ErrorMessage name={name} >
            {errorMsg => <Alert severity='error' >{errorMsg}</Alert>}
          </ErrorMessage>
    
        </Box>
     
     );
}

export default InputField;
